export const filterArchivedPlacements = (placementsData) => {
    return Object.keys(placementsData).reduce((acc, adUnit) => ({
        ...acc,
        [adUnit]: placementsData[adUnit].filter((placement) => {
            return !placement.archived && !!placement.delivery;
        })
    }), {});
};

export default {
    filterArchivedPlacements
};
